


export interface DefaultAndValue {
  default: string;
  value: string;
  morePresets?: string[];
}

export default function restore(key, setter) {
  const storedValue = localStorage.getItem(key);
  if (storedValue) {
    setter(storedValue);
  }
}

export function restore2(key, defaultValue, setter) {
  const storedValue = localStorage.getItem(key);
  setter({
    default: defaultValue,
    value: storedValue || defaultValue
  });
}

export function storedOrDefault(key, defaultValue): string {
  const storedValue = localStorage.getItem(key);
  return storedValue || defaultValue;
}